import { AddContractDialoge } from '../../../contracts/addContractDialog';
import { ListNavigationProvider, useListPageNavigation } from '../../../../hooks/listNavigation';
import React, { useState, useCallback, useEffect } from 'react';
import { CustomErrorLogger } from '../../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../../hooks/useHasPermission';
import MachineContractFiltration from './machineContractFiltration';
import { Box, Typography, CircularProgress } from '@mui/material';
import { isObjectEmpty } from '../../../../utils/isObjectEmpty';
import MachineContractGridView from './machineContractGridView';
import MachineContractListView from './machineContractListView';
import { useSelector } from 'react-redux';
import NoRecord from '../../../NoRecord';
import Iconify from '../../../Iconify';
import axios from 'axios';

const ReadMachineContractsTab = () => {

    const machineDetailsData = useSelector((state) => state.MachineDetailsData);
    const hasContractCreatePermission = useHasPermission('contract_create');

    const limit = 30;
    const [loading, setLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [contracts, setContracts] = useState([]);
    const [displayMode, setDisplayMode] = useState(
        JSON.parse(localStorage.getItem('machineContractDisplayMode')) || 'grid'
    );
    const [totalContracts, setTotalContracts] = useState('');
    const [fetchedContracts, setFetchedContracts] = useState();
    const [openAddContract, setOpenAddContract] = useState(false);
    const [filteredRecordCount, setFilteredRecordCount] = useState('');
    const [contractFilters, setContractfilters] = useState(
        JSON.parse(localStorage.getItem('machineContractFilters')) ||
        { debouncedSearch: '', company: '', auto_renew: null, date: null, machine_id: machineDetailsData.id }
    );
    const [sortBy, setSortBy] = useState(
        JSON.parse(localStorage.getItem('machineContractSortBy')) ||
        {
            title: null,
            contract_number: null,
            company: null,
            date: null,
            visit_frequency: null,
        }
    );
    const { scrollRef, offset, setOffset, navigationValue } = useListPageNavigation({
        id: 'machine-contracts',
        pathname: String(machineDetailsData?.id || ''),
        displayMode,
        itemSizes: { grid: 390, list: 70 },
        resetOnFilters: contractFilters,
        resetOnSort: sortBy,
        ready: !loading,
    });


    // const records_count = totalContracts.length;
    const filtersEmpty = isObjectEmpty(contractFilters, ['machine_id']);

    useEffect(() => {
        localStorage.setItem('machineContractFilters', JSON.stringify(contractFilters));
    }, [contractFilters]);

    useEffect(() => {
        localStorage.setItem('machineContractSortBy', JSON.stringify(sortBy));
    }, [sortBy]);

    useEffect(() => {
        localStorage.setItem('machineContractDisplayMode', JSON.stringify(displayMode));
    }, [displayMode]);

    const fetchContracts = useCallback(async () => {
        try {
            const adjustedOffset = Math.max(offset - 10, 0) || 0; // Ensure offset is not negative
            const response = await axios.get('contract', { params: { offset: adjustedOffset, limit, filters: contractFilters, sortBy } });
            if (response.status === 200 || response.status === 201) {
                // Create a copy of the current files array
                const updatedContracts = [];
                // Update the fetched records in their correct positions
                response.data.contractsData.forEach((file, index) => {
                    updatedContracts[adjustedOffset + index] = file;
                });
                // Update the state with the new files array
                setLoading(false)
                setContracts(updatedContracts);
                setFilteredRecordCount(response.data.filteredContractsCount);
                setTotalContracts(response.data.totalContractsCount);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error Fetching contracts:', error);
            CustomErrorLogger(error, 'fetch contracts in contracts page');
        }
    }, [offset, contractFilters, sortBy]);

    const fetchContractsFiltrationArrays = useCallback(async () => {
        try {
            const response = await axios.get('contract/getContractFiltrationArrays', { params: { contractFilters } });
            if (response.status === 200 || response.status === 201) {
                setCompanies(response.data.companyArray);
            }
        } catch (error) {
            console.error('Error Fetching contracts filtration arrays:', error);
            CustomErrorLogger(error, 'fetch contracts filtration arrays in contracts page');
        }
    }, [contractFilters]);

    useEffect(() => {
        fetchContractsFiltrationArrays()
    }, [fetchContractsFiltrationArrays]);

    useEffect(() => {
        fetchContracts();
    }, [fetchContracts]);

    return (
        <ListNavigationProvider value={navigationValue}>
        <Box>
            {(hasContractCreatePermission && !machineDetailsData?.is_archived && totalContracts > 0) &&
                <Box className='invoice_headre_action_box' sx={{ marginBottom: '10px' }} onClick={() => setOpenAddContract(true)}>
                    <Iconify className='invoice_headre_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='invoice_headre_action_title'>Ajouter un contrat</Typography>
                </Box>
            }
            {
                loading ?
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '80vh',
                        }}
                    >
                        <CircularProgress
                            sx={{
                                '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                            }}
                        />
                    </Box>
                    :
                    totalContracts > 0 ?
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <MachineContractFiltration
                                companies={companies}
                                filtersEmpty={filtersEmpty}
                                displayMode={displayMode}
                                setDisplayMode={setDisplayMode}
                                totalContracts={totalContracts}
                                fetchedContracts={fetchedContracts}
                                contractFilters={contractFilters}
                                setContractfilters={setContractfilters}
                                filteredRecordCount={filteredRecordCount}
                                machineContractFiltration={contractFilters}
                                setMachineContractFiltration={setContractfilters}
                            />
                            {displayMode === 'grid' ?
                                <MachineContractGridView
                                    scrollRef={scrollRef}
                                    setOffset={setOffset}
                                    records_count={totalContracts}
                                    filteredRecordCount={filteredRecordCount}
                                    setFetchedContracts={setFetchedContracts}
                                    contracts={contracts}
                                />
                                :
                                <MachineContractListView
                                    sortBy={sortBy}
                                    setSortBy={setSortBy}
                                    setOffset={setOffset}
                                    scrollRef={scrollRef}
                                    contractFilters={contractFilters}
                                    setContractFilters={setContractfilters}
                                    companies={companies}
                                    records_count={totalContracts}
                                    filteredRecordCount={filteredRecordCount}
                                    setFetchedContracts={setFetchedContracts}
                                    contracts={contracts}
                                />
                            }
                        </Box>
                        :
                        <NoRecord
                            description="Aucun contrat ajouté pour le moment"
                            buttonTitle="Ajouter un nouveau contrat"
                            handleOpenDialog={() => setOpenAddContract(true)}
                            hasPermission={hasContractCreatePermission && !machineDetailsData?.is_archived}
                        />
            }
            {openAddContract &&
                <AddContractDialoge
                    fromMachine={true}
                    openAddContract={openAddContract}
                    setOpenAddContract={setOpenAddContract}
                    machine_ids={[machineDetailsData.id]}

                />}
        </Box>
        </ListNavigationProvider>
    );
}

export default ReadMachineContractsTab;